import React from "react";
import PropTypes from "prop-types";
import ReactDataSheet from "react-datasheet";

import "react-datasheet/lib/react-datasheet.css";
import "./SpreadsheetBlock.css";

import Aux from "../../../../../components/utility/Aux";
import SpreadsheetControls from "./SpreadsheetControls";
import SheetRenderer from "./SheetRenderer";
import RowRenderer from "./RowRenderer";

/**
 * SpreadsheetBlock: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Manuscript content block to display a spreadsheet
 * which can be edited
 *
 * @param {*} props
 */
const SpreadsheetBlock = props => (
  <Aux>
    <ReactDataSheet
      data={props.block.grid}
      valueRenderer={cell => cell.value}
      onCellsChanged={changes => {
        /**
         * Creates a copy of the prop grid in order
         * to prevent accidental reference mutations
         */
        const grid = props.block.grid.map(row => [...row]);

        /**
         * Iterates through the changes in the cells as per
         * event and stores them in the block
         */
        changes.forEach(({ row, col, value }) => {
          grid[row][col] = { ...grid[row][col], value };
        });

        /**
         * Performs a shallow copy of the block to ensure
         * non-mutation of the object
         */
        const block = Object.assign({}, props.block);
        block.grid = grid;

        /**
         * Passes on new block data upwards to the editor
         */
        props.onChange(block);
      }}
      sheetRenderer={SheetRenderer}
      rowRenderer={RowRenderer}
      overflow="nowrap"
    />
    {props.isReadOnlyMode ? null : <SpreadsheetControls {...props} />}
  </Aux>
);

SpreadsheetBlock.propTypes = {
  /**
   * block: {grid: [{}]}
   * Stored grid of the spreadsheet data
   */
  block: PropTypes.shape({
    grid: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({})))
  }).isRequired,

  /**
   * isReadOnlyMode: Boolean
   * If true, the spreadsheet is restricted to view-only
   */
  isReadOnlyMode: PropTypes.bool.isRequired,

  /**
   * onChange: updatedBlock => ()
   * Fired when a change within the spreadsheet has occurred
   * and passes on updated block data
   */
  onChange: PropTypes.func.isRequired
};

export default SpreadsheetBlock;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/blocks/spreadsheet/SpreadsheetBlock.js